module.exports = __webpack_public_path__ + "media/img/hartmannbund-logo-5b0882cbbe6dc415d553a766b33ad519.svg";